import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { GridBaseCase } from "../grid.base.case";
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from '../../../../service/httpcustomer.service';
import { WebParameterContext } from '../../../../model/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { CommonService } from '../../../../service/common.service';
import { HandleWebParameterContextBeforeDBRequest, HandleServerContextAfterDBRequest } from '../../../../bizlogic/servicesbll';
import { BaseCase } from 'src/app/basecase';

declare var app;

@Component({
  selector: 'app-mz-grid-list-visited',
  templateUrl: './mz-grid-list-visited.component.html',
  styleUrls: ['./mz-grid-list-visited.component.scss']
})
export class MzGridListVisitedComponent extends GridBaseCase {
  dataArrayList: Array<any> = [];
  @Input() data: any;//接收父组件的值
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  PageNumber: any = 1;//第一页
  PageName = null;
  constructor(
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private platform: Platform,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase
  ) {
    super();
    this.PageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
  }
  ngOnChanges() {
    // console.log(1001011);
    this.bindData(1);
  }
  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      that.infiniteScroll.disabled = true;
    } else {
      that.PageNumber++;
      this.bindData(that.PageNumber);
    }
  }
  ngAfterViewInit(): void {
    const date = this.activaRouter.snapshot.paramMap.get('type');
    const PageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
    if (PageName == 'HistoryVisitList' && date) {
      const d = date.split("-")[1] + '月' + date.split("-")[2] + '日';
      this.baseService.pageTitle = d;
    }
  }
  bindData(PageNumber) {
    let that = this;
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.SpecialParameter = "Completed";//正在拜访
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (!that.com.GetAccount.IsAdmin) {//S003表示拜访成功
      let startDate = that.com.getNow + " 00:00:00";
      let endDate = that.com.getNow + " 23:59:59";
      let date = that.com.BetweenDate(startDate, endDate);
      body.RequestBody = JSON.stringify({ "a_FK_SystemUser_ID": that.com.GetAccount.Id, "a_Code": 'S003', "a_VisitDate": date });
      // body.RequestBody= JSON.stringify({"a_FK_SystemUser_ID":that.com.GetAccount.Id,"a_ObjectCode":'S003'});
    }
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    body = HandleWebParameterContextBeforeDBRequest(body);
    if (!body.ResponseMessage.Success) {
      that.msg.Alert(body.ResponseMessage.ErrorMessage);
      return;
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      data = HandleServerContextAfterDBRequest(body, data);
      /****判断是否第一页begin****/
      if (PageNumber == 1) {
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      } else {
        that.infiniteScroll.complete();
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
            }
          });
          that.dataArrayList.push(objfield);
          // console.log(that.element.selectItemList.selectItem);
          //console.log(that.dataArrayList);
        });
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if (that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length) {
          that.infiniteScroll.disabled = true;
        } else {
          that.infiniteScroll.disabled = false;
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    })
  }
  EventLink(ev: any, parms: any) {
    let evs = ev.url || '';
    // console.log(parms);
    if (evs.trim() && parms) {
      if(parms["fk_store_id"]){
        localStorage.setItem("tbstore",JSON.stringify({"ID":parms["fk_store_id"].value,"address":parms["address"].value,"name":parms["name"].value}));
      }
      // console.log("协防");
      if(parms["isvisit"].value){//临访
        localStorage.setItem("isvisit",parms["isvisit"].value);
      }else{//非临访
        localStorage.removeItem("isvisit");
      }
      if (evs.indexOf("http") > 0) {
        if (parms.title) {
          this.com.goWebPage(evs, parms.title);
        } else {

        }
       
      } else {
        localStorage.setItem('element', JSON.stringify(ev));
        // console.log({"lng":parms.lng.value,"lat":parms.lat.value});
        let location: any = { "lng": 0, "lat": 0 };
        if (parms.lng.value && parms.lat.value) {
          location = JSON.stringify({ "lng": parms.lng.value, "lat": parms.lat.value });
        }
        localStorage.setItem("mapmun", location);
        this.com.setHistoryUrl();
        // this.router.navigateByUrl(evs + "/add/" + parms.ID.value + "&"+this.com.getNowDatetime);
        this.com.Go(evs + "/add/" + parms.ID.value + "&"+this.com.getNowDatetime);
      }
    }
  }
  /**
* 下拉刷新数据
* @param event
*/
  doRefresh(event) {
    this.bindData(1);
    setTimeout(()=>{
      event.target.complete();
    },300);
  }
  slideOpts = {
    effect: 'slide',
    speed: 1500,
    loop: true,
    slidesPerView: 2,
    direction: "vertical",
    autoplay: {
      delay: 3000
    }
  };
}